<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="whats-in-my-book">
<h1>What’s in My Book?</h1>
<div class="section level2" id="extra-bits-and-pieces">
<h2>Extra Bits and Pieces:</h2>
<p><em>An up-date on those we met in Aubusson</em></p>
<p><em>My reflections on this delightful adventure</em></p>
<p><em>“Aubusson” the poem I wrote whilst there</em></p>
<p><em>Our costs and how to get there</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?3c7613f0